/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
import Axios from 'axios';
import Cookies from 'js-cookie';
import React from 'react';
import Visibility from 'react-visibility-sensor';

export default class VisibilityPixel extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            hasFired: false,
        };
    }

    onVisChange(isVis) {
        const { hasFired } = this.state;
        if (isVis && !hasFired) {
            this.setState({ hasFired: true });
            const { visibilityCallback, metrics } = this.props;
            if (visibilityCallback) visibilityCallback();

            if (!metrics) {
                return;
            }

            metrics.type = 'pixel';

            EmitMetric(metrics, 'pixel');
        }
    }

    static setLastActionParams = (lac, lat) => {
        const trackingPropsHsh = getTrackingPropsCookie() || {};

        trackingPropsHsh.last_action_category = lac;
        trackingPropsHsh.last_action_type = lat;

        Cookies.set('TRACKING_PROPS', `j:${JSON.stringify(trackingPropsHsh)}`, {
            expires: 1 / 12, // 2 hours
            sameSite: 'None',
            secure: true,
        });
    };

    render() {
        return (
            <div style={{ width: '1px', height: '1px' }}>
                <Visibility onChange={(isVis) => this.onVisChange(isVis)}>
                    <div style={{ width: '1px', height: '1px' }} />
                </Visibility>
            </div>
        );
    }
}

const isDebug = () => {
    if (window && window.globalPageData && window.globalPageData.analytics) {
        return window.globalPageData.analytics.debug === true;
    }
    return false;
};

const buildMetrics = (metrics, type) => {
    metrics.url = window.location.pathname;
    const url = new URL(window.location);

    if (url.searchParams.get('utm_source')) {
        metrics.utmSource = url.searchParams.get('utm_source');
    }

    if (url.searchParams.get('utm_campaign')) {
        metrics.utmCampaign = url.searchParams.get('utm_campaign');
    }

    if (url.searchParams.get('utm_medium')) {
        metrics.utmMedium = url.searchParams.get('utm_medium');
    }

    if (url.searchParams.get('LAT')) {
        metrics.last_action_type = url.searchParams.get('LAT');
    }

    if (url.searchParams.get('LAC')) {
        metrics.last_action_category = url.searchParams.get('LAC');
    }

    // Include incoming referrer if exists
    const referrer = getValueFromTrackingProps('referrer');
    if (referrer) {
        metrics.referrer = referrer;
    }

    if (isDebug()) {
        // eslint-disable-next-line no-console
        console.log(`Debug ${type} metrics:`, metrics);
    }

    const metricsString = JSON.stringify(metrics);
    return encodeURIComponent(metricsString);
};

const getPageMetrics = () => {
    let metricsData = { source: 'frontend' };
    if (
        window
        && window.globalPageData
        && window.globalPageData.analytics
        && window.globalPageData.analytics.metrics
    ) {
        metricsData = window.globalPageData.analytics.metrics;
    }

    return metricsData;
};

const getMetricData = (metrics) => {
    const fullMetrics = { ...getPageMetrics(), ...metrics };
    return fullMetrics;
};

export const EmitPage = (metrics = {}, frontendRoutingEnabled) => {
    if (!window || (window.pageMetricsFired === 1 && !frontendRoutingEnabled)) {
        return;
    }

    if (window) {
        window.pageMetricsFired = 1;
    }
    try {
        Axios.get(
            `/_metrics/page?metrics=${buildMetrics(
                getMetricData(metrics),
                'page'
            )}`
        );
    } catch (e) {
        window.pageMetricsFired = 1;
    }
};

export const EmitMetric = (metrics = {}) => {
    Axios.get(
        `/_metrics/emit?metrics=${buildMetrics(getMetricData(metrics), 'emit')}`
    );
};

export const getTrackingPropsCookie = () => {
    const trackingProps = Cookies.get('TRACKING_PROPS');

    return trackingProps ? JSON.parse(trackingProps.split('j:')[1]) : null;
};

export const getValueFromTrackingProps = (key) => {
    const trackingPropsHsh = getTrackingPropsCookie();

    return trackingPropsHsh ? trackingPropsHsh[key] : null;
};
